<section class="legal-header section section__bg-gradient-parent">
  <div class="legal-header__background" aria-hidden="true">
    <picture>
      <source media="(max-width: 600px)" srcset="/assets/legal/header-bg-sm.jpg" />
      <img
        class="legal-header__background-img"
        fill
        priority
        ngSrc="/assets/legal/header-bg.jpg"
        alt="Header background"
      />
    </picture>
  </div>

  <div class="legal-header__inner container">
    <h1 class="legal-header__title title">{{ title() }}</h1>
  </div>
</section>
